import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SitesContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { Sites } from '~src/ts/siteManagement/services/resources/Sites';

import { getNoDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const SiteDefinition: ExplorableItemDefinition = {
  itemType: 'site',
  pluralName: Messages.sites,
  singularName: Messages.site,
  emptyStateMessage: Messages.sitesEmptyMessage,
  contentFilterKeys: SitesContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['site']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const sitesResource = Sites.instance;
    return sitesResource.all().withExtraParams(SitesContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
